import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Panel} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {CommonModal} from 'components/common';
import AwardTable from './AwardTable';
import AwardCreation from './AwardCreation';
import {fetchAwards, setCurrentAwardPage, setCurrentAward, clearAwardsAfterPage} from 'actions/awards';
import * as permissions from 'utils/permissions';

class AwardList extends React.Component {
  static propTypes = {
    awardPages: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      modalShown: false,
      refreshTableKey: 0,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleCreationSuccess = this.handleCreationSuccess.bind(this);
  }

  showModal() {
    this.setState({
      modalShown: true,
    });
  }

  closeModal() {
    this.setState({
      modalShown: false,
    });
  }

  handleCreationSuccess() {
    this.setState((prevState) => ({
      modalShown: false,
      refreshTableKey: prevState.refreshTableKey + 1,
    }));
  }

  render() {
    const {modalShown, refreshTableKey} = this.state;
    const {role} = this.props;
    const {awardPages, fetchAwards, setCurrentAwardPage, setCurrentAward, clearAwardsAfterPage} = this.props;
    return (
      <div>
        {permissions.isKluwellAdmin(role) && (
          <CommonModal title="Create New Award" onClose={this.closeModal} show={modalShown}>
            <AwardCreation onSubmitSuccess={this.handleCreationSuccess} />
          </CommonModal>
        )}
        <div className="container content-box">
          <Panel>
            <h3 className="section-header">
              <div className="section-title">Awards</div>
              {permissions.isKluwellAdmin(role) && (
                <Button variant="contained" color="primary" className="pull-right" onClick={this.showModal}>
                  Create Award
                </Button>
              )}
            </h3>
            <AwardTable
              {...{
                refreshTableKey,
                recordPages: awardPages,
                fetchRecords: (q, page, perPage, sortOpts, extraFilters = {}) =>
                  fetchAwards(q, page, perPage, sortOpts, {...extraFilters, summary: true}),
                setCurrentRecordPage: setCurrentAwardPage,
                setCurrentRecord: setCurrentAward,
                clearRecordsAfterPage: clearAwardsAfterPage,
                hiddenFields: !permissions.isKluwellAdmin(role) ? ['actions'] : undefined,
              }}
            />
          </Panel>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  role: state.account.getIn(['user', 'role']),
  awardPages: state.awards.get('awardPages').toJS(),
});

const mapDispatchToProps = (dispatch) => ({
  fetchAwards: (...args) => dispatch(fetchAwards(...args)),
  setCurrentAwardPage: (...args) => dispatch(setCurrentAwardPage(...args)),
  setCurrentAward: (...args) => dispatch(setCurrentAward(...args)),
  clearAwardsAfterPage: (...args) => dispatch(clearAwardsAfterPage(...args)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AwardList);
